import {createSlice} from "@reduxjs/toolkit";

const initialUserLeaderboardReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  levelsList: [], 
  userLeaderboardreportlist: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const UserLeaderboardReportSlice = createSlice({
  
  name: "userLeaderboardReport",
  initialState: initialUserLeaderboardReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    userLeaderboardReportList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    userLeaderboardReportExport: (state, action) => {
      const { exportData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.exportData = exportData;
      //state.totalCount = totalCount;
    },
    // levelsSearchList: (state, action) => {
    //   const { levelsList } = action.payload;
    //   state.listLoading = false;
    //   state.levelsList = levelsList;
    // },
  }
});
